// Orders API endpoints

import { apiClient } from './client';
import type {
  OrderSubmitRequest,
  OrderReplaceRequest,
  OrderSubmittedResponse
} from '../types/api';

/**
 * Order management API functions
 */
export const ordersApi = {
  /**
   * Submit a new order
   *
   * Requires OrderPlacement permission
   *
   * @param request - Order submission request
   * @returns Order submitted response with order ID and status
   */
  submitOrder: (request: OrderSubmitRequest): Promise<OrderSubmittedResponse> => {
    return apiClient.post<OrderSubmittedResponse>('/api/orders', request);
  },

  /**
   * Cancel an existing order
   *
   * Requires OrderPlacement permission
   *
   * @param orderId - Order UUID to cancel
   * @returns Cancel acknowledgment
   */
  cancelOrder: (orderId: string): Promise<OrderSubmittedResponse> => {
    return apiClient.delete<OrderSubmittedResponse>(`/api/orders/${orderId}`);
  },

  /**
   * Replace (modify) an existing order
   *
   * Requires OrderPlacement permission
   *
   * @param orderId - Order UUID to replace
   * @param request - Replace order request (new quantity/price)
   * @returns Replace acknowledgment with new order ID
   */
  replaceOrder: (orderId: string, request: OrderReplaceRequest): Promise<OrderSubmittedResponse> => {
    return apiClient.patch<OrderSubmittedResponse>(`/api/orders/${orderId}`, request);
  },
};
